// src/app/store/useErrorReportStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ErrorReportStore {
  correlationId: string | null;
  setCorrelationId: (id: string | null) => void;
  clearCorrelationId: () => void;
}

export const useErrorReportStore = create<ErrorReportStore>()(
  persist(
    (set) => ({
      correlationId: null,

      setCorrelationId: (id: string | null) => {
        set({ correlationId: id });
      },

      clearCorrelationId: () => {
        set({ correlationId: null });
      },
    }),
    {
      name: 'error-report-storage', // unique name for localStorage
    }
  )
);
